module.exports = __webpack_public_path__ + "static/img/AI.9c24e0af.gif";